module.exports = __webpack_public_path__ + "img/map-general_flower.a59d5b55.jpg";